import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Chat from "./pages/Chat";
import Bookings from "./pages/Bookings";
import Profile from "./pages/Profile";
import NearbyProviders from "./pages/NearbyProviders";
import Subscriptions from "./pages/Subscriptions";
import Emergency from "./pages/Emergency";
import HealthTips from "./pages/HealthTips";
import Settings from "./pages/Settings";
import PrivacySettings from "./pages/PrivacySettings";
import BottomNav from "./components/BottomNav";
import SOSButton from "./components/SOSButton";
import { onAuthChange, logOut } from "./lib/firebase";
import "@/App.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function AppContent() {
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthChange((firebaseUser) => {
      if (firebaseUser) {
        setUser({
          uid: firebaseUser.uid,
          name: firebaseUser.displayName || firebaseUser.email?.split("@")[0],
          email: firebaseUser.email,
          photo: firebaseUser.photoURL,
        });
      } else {
        setUser(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleSetUser = (userData) => {
    setUser(userData);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-blue-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-600 font-medium">Loading SupaDoc...</p>
        </div>
      </div>
    );
  }

  const showNav = !["/", "/login"].includes(location.pathname);
  const showSOS = user && !["/", "/login", "/emergency"].includes(location.pathname);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100">
      <Routes>
        <Route path="/" element={<Landing user={user} setUser={handleSetUser} />} />
        <Route path="/login" element={!user ? <Login setUser={handleSetUser} /> : <Navigate to="/chat" />} />
        <Route path="/chat" element={<Chat user={user} />} />
        <Route path="/bookings" element={<Bookings user={user} />} />
        <Route path="/profile" element={<Profile user={user} setUser={handleSetUser} />} />
        <Route path="/nearby" element={<NearbyProviders user={user} />} />
        <Route path="/subscriptions" element={<Subscriptions user={user} setUser={handleSetUser} />} />
        <Route path="/emergency" element={<Emergency user={user} />} />
        <Route path="/health-tips" element={<HealthTips user={user} />} />
        <Route path="/settings" element={<Settings user={user} setUser={handleSetUser} />} />
        <Route path="/privacy" element={<PrivacySettings user={user} />} />
      </Routes>

      {showSOS && <SOSButton />}
      {showNav && <BottomNav user={user} />}
      <Toaster position="top-center" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
